/**
 * Chat de jets VtM en Realtime DB (API modulaire), au même chemin que pour Aria : /{idCampagne}.
 * Contrairement à Aria (qui réécrit toute la liste), chaque jet est ajouté avec push() :
 * deux jets simultanés ne peuvent pas s'écraser.
 */
import {getDatabase, ref, push, set, update, onValue} from 'firebase/database';
import {normalizeRollRecord} from './rolls';

const campaignRef = (campaignUid) => ref(getDatabase(), campaignUid);

/** @returns {Promise<String>} clé Firebase du jet */
export const pushRoll = async (campaignUid, record) => {
  const newRef = push(campaignRef(campaignUid));
  await set(newRef, record);
  return newRef.key;
};

export const updateRoll = (campaignUid, key, patch) => update(ref(getDatabase(), `${campaignUid}/${key}`), patch);

/**
 * Écoute les jets d'une campagne, du plus ancien au plus récent.
 * @returns {Function} désabonnement
 */
export const watchRolls = (campaignUid, onChange) => onValue(campaignRef(campaignUid), snapshot => {
  const value = snapshot.val() || {};
  const rolls = Object.entries(value)
    .filter(([, roll]) => roll && roll.system === 'vtm5')
    .map(([key, roll]) => normalizeRollRecord(key, roll))
    // À horodatage égal, la clé push (chronologique) départage : l'ordre ne dépend pas de celui des clés reçues
    .sort((a, b) => ((a.createdAt || 0) - (b.createdAt || 0)) || (a.key < b.key ? -1 : 1));
  onChange(rolls);
});
